// eslint-disable-next-line import/no-cycle
import { APIService } from './ApiService';

export const getInvites = () => APIService.get('community/discord/invites');

export const createInvite = () => APIService.post('community/discord/invites');

export const getVerificationInfo = () => APIService.get('community/discord/user/verify');

export const verifyDiscordUser = () => APIService.post('community/discord/user/verify');

export const getDiscordUser = () => APIService.get('community/discord/user');

export const getIsUserQualifiedForCommunity = () => APIService.get('community/discord/user/qualified');

export const getAllInvites = ({ page, limit, search, inviteCode }) =>
  APIService.get('community/discord/invites/all', {
    params: {
      page,
      limit,
      search,
      inviteCode,
    },
  });

export const getAllDiscordUsers = ({ page, limit, search, status }) =>
  APIService.get('community/discord/users/all', {
    params: {
      page,
      limit,
      search,
      status,
    },
  });

export const refreshDiscordUserData = userId => APIService.put(`community/discord/user/${userId}/refresh-data`);

export const overrideDiscordUserStatus = ({ userId, status }) =>
  APIService.put(`community/discord/user/${userId}/status`, {
    status,
  });

export const declineInvite = inviteId => APIService.put(`community/discord/invite/${inviteId}/decline`);

export const unbanDiscordUser = userId => APIService.put(`community/discord/user/${userId}/unban`);

export const getUserDiscordUserById = userId =>
  APIService.get(`community/discord/user/by-user/${userId}`, {
    params: {
      userId,
    },
  });

export const getUserDiscordInvitesById = userId =>
  APIService.get(`community/discord/invites/by-user/${userId}`, {
    params: {
      userId,
    },
  });

export const updateUserExamYearOnDiscord = userId =>
  APIService.put(`community/discord/user/${userId}/update-exam-year`, {
    userId,
  });
